import { render, staticRenderFns } from "./room-facility-list.vue?vue&type=template&id=6a34ec9e"
import script from "./room-facility-list.vue?vue&type=script&lang=ts"
export * from "./room-facility-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports